export default {
  'byMovimentsForm.form.filterByData': 'Filter by Date From (O.S.)',
  'byMovimentsForm.form.filterByData.entry': 'Entry',
  'byMovimentsForm.form.filterByData.authorization': 'Authorization',
  'byMovimentsForm.form.filterByData.closing': 'Closing',
  'byMovimentsForm.form.situation': 'Situation of the O.S.',
  'byMovimentsForm.form.situation.authorized': 'Authorized',
  'byMovimentsForm.form.situation.closed': 'Closed',
  'byMovimentsForm.form.situation.open': 'Open',
  'byMovimentsForm.form.situation.checkbox.parts': 'Parts',
  'byMovimentsForm.form.situation.checkbox.suppliedParts': 'Supplied Parts',
  'byMovimentsForm.form.situation.checkbox.services': 'Services',
  'byMovimentsForm.form.situation.checkbox.the3rd': 'the 3rd',
  'byMovimentsForm.form.situation.checkbox.directSale': 'DirectSale',
  'byMovimentsForm.form.reportYype': 'Select the Report Type',
  'byMovimentsForm.form.reportYype.salesmanEstimator':
    'Estimator / Salesperson',
  'byMovimentsForm.form.reportYype.employeePerItem': 'Employee by O.S.',
  'byMovimentsForm.form.reportYype.paintedPiece': 'Painted Piece',
  'byMovimentsForm.form.selectCalculationType.title': 'Select Calculation Type',
  'byMovimentsForm.form.selectCalculationType.baseValue': 'Base Value',
  'byMovimentsForm.form.selectCalculationType.netValue': 'Net Value',
  'byMovimentsForm.form.selectCalculationType.checkbox.detailItemsSold':
    'Detail Items Sold',
  'byMovimentsForm.form.selectCalculationType.checkbox.inhibitNetValue':
    'Inhibit Net Value',
};
